const brandingColorsByCoreCategory: Record<
  string,
  { background: string; badge: string; decoration: string; text: string } | undefined
> = {
  'Chocolates & Sweets': {
    background: 'bg-[#9396EE]',
    badge: 'bg-[#2D2B73]',
    decoration: 'decoration-[#9396EE]',
    text: 'text-[#2D2B73]',
  },
  'Dried Fruit': {
    background: 'bg-nuts-lime-600',
    badge: 'bg-[#034F04]',
    decoration: 'decoration-nuts-lime-600',
    text: 'text-[#034F04]',
  },
  'Nuts & Seeds': {
    background: 'bg-[#F4A620]',
    badge: 'bg-[#4A1F0D]',
    decoration: 'decoration-[#F4A620]',
    text: 'text-[#4A1F0D]',
  },
  Pantry: {
    background: 'bg-nuts-sky-600',
    badge: 'bg-nuts-sky-950',
    decoration: 'decoration-nuts-sky-600',
    text: 'text-nuts-sky-950',
  },
  Snacks: {
    background: 'bg-nuts-orange-600',
    badge: 'bg-[#4A1F0D]',
    decoration: 'decoration-nuts-orange-600',
    text: 'text-[#4A1F0D]',
  },
};

export const brandingColorsByCategory: Record<
  string,
  { background: string; badge: string; decoration: string; text: string } | undefined
> = {
  ...brandingColorsByCoreCategory,
  'Bakery Snacks': brandingColorsByCoreCategory.Snacks,
  Breakfast: brandingColorsByCoreCategory.Pantry,
  Nuts: brandingColorsByCoreCategory['Nuts & Seeds'],
  'Coffees & Teas': brandingColorsByCoreCategory.Pantry,
  Powders: brandingColorsByCoreCategory.Pantry,
  Seeds: brandingColorsByCoreCategory['Nuts & Seeds'],
};
